import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as TimesheetImage } from 'assets/svgs/timesheet-feature.svg';
import { Button } from 'components/atoms/button';
import { FeatureDiscovery } from 'components/molecules/feature-discovery';
import { Page } from 'components/molecules/page';
import { RoutePaths } from 'constant';
import { useTranslation } from 'hooks/use-translation';

const {
  Header: { Title: PageTitle },
} = Page;

const {
  Section: { Content, Media },
} = FeatureDiscovery;

const TimesheetFeatuteDiscovery: FC = () => {
  const { push } = useHistory();

  return (
    <FeatureDiscovery>
      <FeatureDiscovery.Section>
        <Content>
          <Content.Title>
            {useTranslation('timesheets.feature_discovery.title')}
          </Content.Title>
          <Content.List>
            <Content.List.Item>
              {useTranslation('timesheets.feature_discovery.point_1')}
            </Content.List.Item>
            <Content.List.Item>
              {useTranslation('timesheets.feature_discovery.point_2')}
            </Content.List.Item>
            <Content.List.Item>
              {useTranslation('timesheets.feature_discovery.point_3')}
            </Content.List.Item>
          </Content.List>
          <Content.Actions>
            <Button
              type="primary"
              onClick={() => push(RoutePaths.timesheetSettings)}
            >
              {useTranslation('timesheets.feature_discovery.action')}
            </Button>
          </Content.Actions>
        </Content>
        <Media>
          <TimesheetImage />
        </Media>
      </FeatureDiscovery.Section>
    </FeatureDiscovery>
  );
};

export const TimesheetFeatureDiscovery: FC = () => (
  <Page data-cy-page="timesheet-feature-discovery">
    <Page.Header
      title={<PageTitle>{useTranslation('menu.label.timesheets')}</PageTitle>}
    />
    <Page.Content>
      <TimesheetFeatuteDiscovery />
    </Page.Content>
  </Page>
);
